<template>
  <jr-table
    :loading="loading"
    :tableData="list"
    :tableColumn="tableColumn"
  >
    <template v-slot:idNumber="{row, column}">
      <page-encrypt-icon
        :value.sync="row[`${column.prop}-new`]"
        :encryptValue="row.idNumber"
      />
    </template>
    <template v-slot:idNationUrl="{row}">
      <span v-if="!row.idNationUrl">-</span>
      <jr-preview-image
        v-else
        :row-id="row.idNumber"
        :image-list="$stringToArray(row.idNationUrl)"
      />
    </template>
    <template v-slot:idFaceUrl="{row}">
      <span v-if="!row.idFaceUrl">-</span>
      <jr-preview-image
        v-else
        :row-id="row.idNumber"
        :image-list="$stringToArray(row.idFaceUrl)"
      />
    </template>
  </jr-table>
</template>

<script>
import { getCustomerContact } from '@/api/servicer';

export default {
  name: 'ContactInfo',
  props: {
    // 客户财务编号
    customerNo: {
      tyoe: String,
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      tableColumn: [
        { prop: 'role', label: '联系人角色', minWidth: '1' },
        { prop: 'name', label: '联系人姓名', minWidth: '1' },
        { prop: 'idType', label: '证件类型', minWidth: '1' },
        { label: '证件号码', prop: 'idNumber', slotName: 'idNumber' },
        { prop: 'idValidity', label: '证件有效期', minWidth: '1', filterName: 'formatTime(yyyy-MM-dd)' },
        { label: '国徽', status: 'idNationUrl', slotName: 'idNationUrl' },
        { label: '人脸', status: 'idFaceUrl', slotName: 'idFaceUrl' },
      ],
    };
  },
  methods: {
    init() {
      this.getInfo();
    },
    async getInfo() {
      try {
        this.loading = true;
        const res = await getCustomerContact({ customerNo: this.customerNo });
        this.loading = false;
        this.list = res.data || [];
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.list = [];
      }
    },
  },
};
</script>
